import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';


//Function to split data 
const splitSyDiPrData = (SyDiPrData) => {
    
    var s_Cleaned_Data = SyDiPrData.replace("S", "");
    var splitted_PrPs_PrPd_Data = s_Cleaned_Data.split("D");
    
    var splitted_PrPd_PrPr_Data = splitted_PrPs_PrPd_Data[1].split('P');

    var splitted_Data = [splitted_PrPs_PrPd_Data[0], splitted_PrPd_PrPr_Data[0], splitted_PrPd_PrPr_Data[1]]

    return splitted_Data;

}


const formatAndMergeTensiometerData = (fullLoad, oldTensiometerData, newTensiometerData) => {

    let local_data = {'systolic': [], 'diastolic': [], 'pulseRate': []};
    let isANewDateValue = "";

    // Reset data if new load
    if (fullLoad){
        oldTensiometerData = []
    }
    
    if (oldTensiometerData !== undefined){
        Utils.mergeBasicOldData(oldTensiometerData.systolic, local_data.systolic)
        Utils.mergeBasicOldData(oldTensiometerData.diastolic, local_data.diastolic)
        Utils.mergeBasicOldData(oldTensiometerData.pulseRate, local_data.pulseRate)
    }

    if (newTensiometerData !== undefined){
        if(newTensiometerData.length !== 0){
            let Sy_Di_Pr_Splitted_Data;
            for (var i = newTensiometerData.length-1; i >= 0; i--){        // Find new values and add it
                isANewDateValue = local_data.pulseRate.find(xDate => { return xDate.x === new Date(newTensiometerData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){                 
                    Sy_Di_Pr_Splitted_Data = splitSyDiPrData(newTensiometerData[i].value); // separate Pr and Sp02
                    local_data.diastolic.push(  {x: new Date(newTensiometerData[i].eventDate).getTime(), y: Sy_Di_Pr_Splitted_Data[1]});
                    local_data.systolic.push(       {x: new Date(newTensiometerData[i].eventDate).getTime(), y: Sy_Di_Pr_Splitted_Data[0]});
                    local_data.pulseRate.push(         {x: new Date(newTensiometerData[i].eventDate).getTime(), y: Sy_Di_Pr_Splitted_Data[2]});
                }
            }
        }
    }
    return local_data;
}




//Function to get last good spO2 data
const getLastTensionDataAndColor = (dataset, threshold_sys, threshold_sys2, threshold_dia, threshold_dia2) => {

    let tensiometerData = {
        systolic: "-",
        diastolic: "-",
        color: "#767676"
    };

    if((dataset !== undefined)&&(dataset.systolic.length > 0)){
        //Set systolic val
        tensiometerData.systolic = dataset.systolic[dataset.systolic.length-1].y
        //Set diastolic val
        tensiometerData.diastolic = dataset.diastolic[dataset.diastolic.length-1].y
        //Set color val
        if (threshold_sys2 === null || threshold_sys2 === undefined) {
            threshold_sys2 = Utils.setDefaultThreshold2("tension")
        }
        if (threshold_dia2 === null || threshold_dia2 === undefined) {
            threshold_dia2 = Utils.setDefaultThreshold2("tension")
        }
        let systolic_color = Utils.setMeasureColor(dataset.systolic[dataset.systolic.length-1].y, threshold_sys, 10, 'sup', threshold_sys2);
        let diastolic_color = Utils.setMeasureColor(dataset.diastolic[dataset.diastolic.length-1].y, threshold_dia, 10, 'sup', threshold_dia2);
        if (systolic_color === "#DB2828" || diastolic_color === "#DB2828") {
            tensiometerData.color = "#DB2828"
        }
        else if (systolic_color === "#F2711C" || diastolic_color === "#F2711C") {
            tensiometerData.color = "#F2711C"
        }
        else {
            tensiometerData.color = systolic_color
        }
    }
    return (tensiometerData);
}

//Function to get last pulse rate data
const getLastPulseRateDataAndColor = (dataset, threshold, threshold2) => {

    let pulseRateData = {
        pulseRate: "-",
        color: "#767676"
    };

    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set pulse rate value
        pulseRateData.pulseRate = dataset[dataset.length-1].y
        //Set pulse rate color
        if (threshold2 === null || threshold2 === undefined) {
            threshold2 = Utils.setDefaultThreshold2("pulse_rate")
        }
        pulseRateData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 10, 'sup', threshold2);
    }
    return (pulseRateData);
}



//Const to import functions in other files
const TensionManager = {
  getLastTensionDataAndColor,
  getLastPulseRateDataAndColor,
  formatAndMergeTensiometerData
};

export default TensionManager;